export default "__VITE_ASSET__Dw4fFjxH__"